export const getRecommendations = (callback = null, productId = null, numberOfResults = 8) => {
  fetch(`/recommendations/products.json?product_id=${productId}&limit=${numberOfResults}&intent=related`)
    .then((response) => response.json())
    .then(({ products }) => {
      if (callback) callback(products)
    })
}
